// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/IMS/IMSManagement.css
// module id = 829
// module chunks = 0